<script setup lang="ts">
import { useProjectStore } from '@/stores/project'
import { storeToRefs } from 'pinia'

const { currentItem } = storeToRefs(useProjectStore())
</script>

<template>
  <v-card class="pb-3" elevation="0">
    <v-tooltip location="bottom" open-delay="500" max-width="300px">
      <template #activator="{ props }">
        <v-card-title class="component-title" v-bind="props">
          {{ currentItem?.name }}
        </v-card-title>
      </template>
      <span> {{ currentItem?.name }}</span>
    </v-tooltip>
    <v-card-subtitle class="component-subtitle" opacity="1">
      <v-chip class="mr-3" prepend-icon="mdi-map-marker" size="x-small" label>
        {{ currentItem?.location }}
      </v-chip>
      <span class="client-font">
        {{ currentItem?.client }}
      </span>
    </v-card-subtitle>
  </v-card>
</template>

<style scoped></style>
